import React from "react";
import Footer from "../Fotter";

function PrebookingPolicy() {
  return (
    <div>
      <div className=" mx-auto px-4 py-12">
        <h2 className="text-4xl font-semibold text-center text-gray-800 mb-12">
          Prebooking Terms and Conditions
        </h2>

        <ul className="list-disc list-inside space-y-2">
          <li>I hereby agree to the following terms of iPhone Registration.</li>
          <li>
            I am voluntarily participating in the iPhone registration program
            and I understand that this program does not guarantee that I will
            receive the preferred iPhone or any other phone or product at the
            time of launch or even within any stipulated timeframe.
          </li>
          <li>
            This registration does not entitle anyone to a confirmed delivery of
            iPhone or any other product from bharatCod.
          </li>
          <li>
            I can Pre-order a maximum of 1 unit from bharatCod as part of the
            iPhone registration program.
          </li>
          <li>
            In case I am offered my preferred model of iPhone, I agree to
            complete the purchase transaction immediately and within a period
            not exceeding 24 hours from offer time.
          </li>
          <li>
            I agree to use the device purchased from bharatCod for individual
            use only and will not resell this device to anybody else.
          </li>
          <li>
            bharatCod will not be liable in any way in case they are not able to
            fulfill my demand of the registered iPhone.
          </li>
          <li>
            In case bharatCod is not able to supply the product as per my
            preference, then refund of advance amount, if any, will be processed
            as per the refund policy.
          </li>
          <li>
            In order to cancel this registration, a written cancellation request
            will need to be submitted by the customer. Any refunds, if
            applicable, on cancellation will be processed as per the refund
            policy.
          </li>
          <li>
            The refunds, if applicable, will be made in mode of cheque only and
            will be processed within 15 days of the cancellation request.
          </li>
          <li>
            In case of advance payments made thru credit or debit card, a
            cancellation charge of 3% will be applicable.
          </li>
          <li>
            bharatCod reserves the right to not disclose any data pertaining to
            customer registrations to any customers or third party under this
            program.
          </li>
          <li>
            bharatCod may share this data with Apple India Pvt. Ltd and its
            Distributors like Ingram Micro India Ltd in case needed for any
            validation of registrations or to enable supplies of products.
          </li>
          <li>
            In case of any dispute, bharatCod reserves the right to cancel this
            registration at any time.
          </li>
        </ul>

        <section className="mt-8">
          <h2 className="text-xl font-semibold mb-4">Customer Support</h2>
          <p>
            <strong>Address:</strong> 403, Shagun Tower, Above Apna Sweets,
            Scheme Number 54,P.u.4,AB Rd,vijay Nagar,Indore,Madhy Pradesh 452010
            Pradesh
          </p>
          <p>
            <strong>Phone:</strong> (+91) 9399456176
          </p>
          <p>
            <strong>E-mail:</strong> info@bharatCod.com
          </p>
          <p>
            <strong>Website:</strong>{" "}
            <a
              href="http://www.bharatCod.com"
              className="text-blue-500 underline"
            >
              www.bharatCod.com
            </a>
          </p>
          <div className="mb-10 flex  space-x-6">
            <a
              href="https://www.facebook.com/thebharatcod"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook fa-2x text-blue-600 hover:text-blue-800"></i>
            </a>
            <a
              href="https://www.instagram.com/bharatcod/#"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram fa-2x text-pink-500 hover:text-pink-700"></i>
            </a>
            <a
              href="https://in.pinterest.com/thebharatcod/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-pinterest fa-2x text-blue-700 hover:text-blue-900"></i>
            </a>
            <a
              href="https://www.youtube.com/channel/UC5TRs6-BjCd9QgDbP8YKvEQ"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-youtube fa-2x text-red-700 hover:text-red-700"></i>
            </a>
          </div>
        </section>  
      </div>
      <Footer />
    </div>
  );
}

export default PrebookingPolicy;
